export default __webpack_public_path__ + "static/media/404.14d7231a.png";